module.exports = __webpack_public_path__ + "static/cat-1-3f4e9b86ff5e7c886a4122c9befab603.png";